"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("./styled"));
const svg_components_1 = require("app/assets/svg-components");
const Typography_1 = require("../Typography");
const Button_1 = __importDefault(require("app/Components/Button"));
const Dialog = ({ title, message, confirmText, onClose, onConfirm }) => {
    return (react_1.default.createElement(styled_1.default.DialogWrapper, null,
        react_1.default.createElement(styled_1.default.DialogContainer, null,
            react_1.default.createElement(styled_1.default.CloseButton, { onClick: onClose },
                react_1.default.createElement(svg_components_1.BurgerClosedIcon, null)),
            react_1.default.createElement(styled_1.default.Title, { type: Typography_1.Types.INTRODUCTORY_TEXT }, title),
            react_1.default.createElement(styled_1.default.Message, { type: Typography_1.Types.BODY_1 }, message),
            react_1.default.createElement(Button_1.default, { onClick: onConfirm }, confirmText))));
};
exports.default = Dialog;
